import Hashids from 'hashids';

export default {
  methods: {
    getAccessToken() {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const token = params.get('token') || null;
      return token;
    },
    getHash() {
      const outputHashids = new Hashids('X5lM3VPyBvm', 32, '0123456789abcdef');
      /* Use a virtual account */
      return outputHashids.encode([5566001, Date.now()]);
    },
  },
};
